import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import axios from "axios";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import SuccessModal from "./SuccessModal";
import FailedModal from "./FailedModal";
import countriesData from "../assets/countries.json";
import sectorsData from "../assets/sectors.json";
import { useState } from "react";

// TEMP: location check disabled — page open for anyone, anywhere
// const TARGET_LOCATION = {
//   lat: 24.75307564954822,
//   lng: 46.724197374260015,
// };

// const EVENT_END = new Date("2026-09-22T21:00:00+03:00");

const CertificateForm = () => {
  const { t, i18n } = useTranslation();
  const [successModal, setSuccessModal] = useState(false);
  const [failedModal, setFailedModal] = useState(false);
  const [policyModal, setPolicyModal] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedGender, setSelectedGender] = useState("");
  const [selectedSector, setSelectedSector] = useState("");
  const [uuid, setUuid] = useState();

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const tog_modal = () => {
    setSuccessModal(!successModal);
    return successModal;
  };

  const tog_failed_modal = () => {
    setFailedModal(!failedModal);
    return failedModal;
  };

  const tog_policy_modal = () => {
    setPolicyModal(!policyModal);
    return policyModal;
  };

  const initialValues = {
    name: "",
    email: "",
    phone: "",
    gender: "",
    job_title: "",
    company: "",
    message: "",
    // ...(!isExhibitor ? {} : { website_url: "" }),
    // ...(!isExhibitor ? {} : { country: "" }),
    // ...(!isExhibitor ? {} : { city: "" }),
    // ...(!isExhibitor ? {} : { sex: "" }),
    // ...(!isExhibitor ? {} : { sector: "" }),
  };

  const countryOptions = countriesData.map((country) => ({
    value: country.name,
    label: i18n.language === "en" ? country.en : country.ar,
  }));

  const genderOptions = [
    {
      value: "male",
      label: i18n.language === "en" ? "male" : "ذكر",
    },
    {
      value: "female",
      label: i18n.language === "en" ? "female" : "أنثى",
    },
  ];

  const sectorOptions = sectorsData.map((sector) => ({
    value: sector.value,
    label: i18n.language === "en" ? sector.en : sector.ar,
  }));

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
  };

  const handleGenderChange = (selectedOption) => {
    setSelectedGender(selectedOption);
  };

  const handleSectorChange = (selectedOption) => {
    setSelectedSector(selectedOption);
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(t("registrationForm.firstNameRequired")),
    // last_name: Yup.string().required(t("registrationForm.lastNameRequired")),
    email: Yup.string()
      .email(t("registrationForm.invalidEmail"))
      .required(t("registrationForm.emailRequired")),
    phone: Yup.string().required(t("registrationForm.phoneRequired")),
    job_title: Yup.string().required(t("registrationForm.jobTitleRequired")),
    // company: Yup.string().required(t("registrationForm.companyRequired")),
    message: Yup.string(),
  });

  const handleSubmit = async (values, { resetForm }) => {
    const url = "https://admin.fmexcon.com/api/certificate-register";

    await axios
      .post(url, {
        ...values,
        phone: `+${values?.phone}`,
        country: selectedCountry?.label,
        gender: selectedGender?.value,
        sector: selectedSector?.label,
      })
      .then((res) => {
        if (res.status === 200) {
          setSuccessModal(true);
          setUuid(res?.data?.data?.uuid);
          resetForm();
        } else {
          setFailedModal(true);
          resetForm();
        }
        resetForm();
      })
      .catch(() => {
        toast.error(t("common.submit_error"));
        throw new Error("Unexpected response");
      });
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "white",
      borderColor: "#e5e7eb",
      borderRadius: "8px",
      padding: "1.5px",
      boxShadow: "none",
      fontWeight: "600",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#013047a8",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#013047" : "white",
      color: state.isSelected ? "white" : "#013047",
      "&:hover": {
        backgroundColor: "#013047",
        color: "white",
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 10,
    }),
  };

  // TEMP: geolocation + event-end check disabled for open access
  // function deg2rad(deg) {
  //   return deg * (Math.PI / 180);
  // }

  // function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  //   const R = 6371;
  //   const dLat = deg2rad(lat2 - lat1);
  //   const dLon = deg2rad(lon2 - lon1);
  //   const a =
  //     Math.sin(dLat / 2) * Math.sin(dLat / 2) +
  //     Math.cos(deg2rad(lat1)) *
  //       Math.cos(deg2rad(lat2)) *
  //       Math.sin(dLon / 2) *
  //       Math.sin(dLon / 2);
  //   const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  //   return R * c;
  // }

  const [allowed] = useState(true);

  // useEffect(() => {
  //   const now = new Date();
  //
  //   // تحقق من الوقت أولاً
  //   if (now > EVENT_END) {
  //     setAllowed(false);
  //     return;
  //   }
  //
  //   if (!navigator.geolocation) {
  //     setAllowed(false);
  //     return;
  //   }
  //
  //   navigator.geolocation.getCurrentPosition(
  //     (position) => {
  //       const userLat = position.coords.latitude;
  //       const userLng = position.coords.longitude;
  //       const distance = getDistanceFromLatLonInKm(
  //         userLat,
  //         userLng,
  //         TARGET_LOCATION.lat,
  //         TARGET_LOCATION.lng
  //       );
  //
  //       if (distance <= 1) {
  //         setAllowed(true);
  //       } else {
  //         setAllowed(false);
  //       }
  //     },
  //     (error) => {
  //       console.error(error);
  //       setAllowed(false);
  //     }
  //   );
  // }, []);

  if (!allowed) {
    return (
      <div className="min-h-[500px] flex justify-center items-center container">
        <p className="text-sm md:text-base font-semibold text-yellow-800 leading-relaxed bg-yellow-100 border border-yellow-400 shadow-md rounded-xl text-center w-full max-w-xl mx-auto p-4 md:p-6">
          <span dir="rtl" className="block mb-2">
            ⚠️ <span className="font-bold">تنبيه:</span> أنت خارج نطاق الحدث .
            <br />
            يرجى التوجه إلى مكان الحدث لطباعة الشهادة
            <br />
            للدعم والمساعدة يرجى الارسال على الرقم
            <a
              href="https://wa.me/966503776726"
              target="_blank"
              rel="noreferrer"
              className="text-blue-500 mx-2 inline-block underline"
            >
              966503776726+
            </a>
          </span>

          <span
            dir="ltr"
            className="block mt-2 border-t border-yellow-300 pt-2 text-xs md:text-sm text-yellow-900"
          >
            ⚠️ <span className="font-bold">Notice:</span> You are outside the
            event area.
            <br />
            please head to the event location to print your certificate
            <br />
            For support, please send to the number
            <a
              href="https://wa.me/966503776726"
              target="_blank"
              rel="noreferrer"
              className="text-blue-500 mx-2 inline-block underline"
            >
              +966503776726
            </a>
          </span>
        </p>
      </div>
    );
  }

  return (
    <div
      className={`container mx-auto my-12 ${
        i18n.language === "en" ? "text-left" : "text-right"
      }`}
      dir={i18n.language === "en" ? "ltr" : "rtl"}
    >
      {/* <div className="mb-9 mt-12 md:text-4xl text-3xl text-text font-bold text-center">
        {t("common.get_certificate")}
      </div> */}

      <SuccessModal
        tog_modal={tog_modal}
        successModal={successModal}
        fromCertificate={true}
        uuid={uuid}
      />
      <FailedModal
        tog_failed_modal={tog_failed_modal}
        failedModal={failedModal}
      />

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue, values, setFieldValues }) => (
          <Form className="w-full mx-auto relative">
            <div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
                <div className="flex flex-col">
                  <Field
                    name="name"
                    placeholder={t("registrationForm.namePlaceholder")}
                    className="w-full bg-white rounded-lg border border-gray-200 outline-none p-2 placeholder:text-[#013047a8] font-semibold"
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>
                <div className="flex flex-col mb-4">
                  <Field
                    name="email"
                    type="email"
                    placeholder={t("registrationForm.emailPlaceholder")}
                    className="w-full bg-white rounded-lg border border-gray-200 outline-none p-2 placeholder:text-[#013047a8] font-semibold"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
                <div className="flex flex-col" dir="rtl">
                  <PhoneInput
                    country="sa"
                    value={values.phone}
                    onChange={(phone) => setFieldValue("phone", phone)}
                    inputProps={{
                      name: "phone",
                      id: "phone",
                      className:
                        "border-[1.5px] px-2 py-[9px]  w-full bg-white  rounded-lg border border-gray-200 phone-input-handle",
                      placeholder: t("registrationForm.phone"),
                    }}
                    dropdownClass="custom-phone-dropdown"
                  />
                  <ErrorMessage
                    name="phone"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>
                <div className="flex flex-col">
                  <Field
                    name="job_title"
                    placeholder={t("registrationForm.jobTitlePlaceholder")}
                    className="w-full bg-white rounded-lg border border-gray-200 outline-none p-2 placeholder:text-[#013047a8] font-semibold"
                  />
                  <ErrorMessage
                    name="job_title"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
                <div className="flex flex-col">
                  <Select
                    options={genderOptions}
                    onChange={handleGenderChange}
                    placeholder={t("registrationForm.gender")}
                    isSearchable
                    styles={customStyles}
                    className="w-full mx-auto py-[1px]"
                  />
                  <ErrorMessage
                    name="gender"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>
                <div className="flex flex-col">
                  <Select
                    options={sectorOptions}
                    onChange={handleSectorChange}
                    placeholder={t("registrationForm.sector")}
                    isSearchable
                    styles={customStyles}
                    className="w-full mx-auto py-[1px]"
                  />
                  <ErrorMessage
                    name="country"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
                <div className="flex flex-col">
                  <Select
                    options={countryOptions}
                    onChange={handleCountryChange}
                    placeholder={t("registrationForm.country")}
                    isSearchable
                    styles={customStyles}
                    className="w-full mx-auto py-[1px]"
                  />
                  <ErrorMessage
                    name="country"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>
                <div className="flex flex-col">
                  <Field
                    name="city"
                    placeholder={t("registrationForm.city")}
                    className="w-full bg-white rounded-lg border border-gray-200 outline-none p-2 placeholder:text-[#013047a8] font-semibold"
                  />
                  <ErrorMessage
                    name="city"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>
              </div>
              <div className="flex flex-col mb-4">
                <Field
                  as="textarea"
                  name="message"
                  placeholder={t("registrationForm.messagePlaceholder")}
                  rows="4"
                  className="w-full bg-white rounded-lg border border-gray-200 outline-none p-2 placeholder:text-[#013047a8] font-semibold"
                />
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                  className="tracking-wide cursor-pointer"
                  required
                />
                <span className="mx-[6px] tracking-normal">
                  {t("registrationForm.accept")}
                </span>{" "}
                <div
                  onClick={tog_policy_modal}
                  className="text-text underline tracking-normal cursor-pointer"
                >
                  {t("registrationForm.terms")}
                </div>
              </div>
              <div className="text-center">
                <button
                  type="submit"
                  className="px-6 py-2 bg-text hover:bg-text_hover text-white rounded-lg"
                >
                  {t("common.get_certificate")}
                </button>
              </div>
              <div className="text-center lg:mt-6 lg:text-lg">
                {" "}
                {t("common.for_support")}
                <a
                  href="https://wa.me/966503776726"
                  target="_blank"
                  rel="noreferrer"
                  className="text-blue-500 mx-2 inline-block underline"
                >
                  {t("common.number")}
                </a>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default CertificateForm;
